import { render } from "./SubscriptionComponent.vue?vue&type=template&id=f22a5a4a"
import script from "./SubscriptionComponent.vue?vue&type=script&lang=js"
export * from "./SubscriptionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__